import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import PrimaryButton from "../../shared/PrimaryButton";
import { fetchOnboardingLink } from "../../../util/admin/httpAdmin";
import LoadingIndicatorButton from "../../shared/LoadingIndicatorButton";

const OnboardingButton = ({ subdomain }) => {
   const {
      data: onboardingLink,
      isLoading,
      isError,
   } = useQuery({
      queryKey: ["onboardingLink", subdomain],
      queryFn: fetchOnboardingLink,
      enabled: !!subdomain, // Alleen fetchen als subdomain bestaat
   });

   const [isButtonLoading, setIsButtonLoading] = useState(false);

   const handleOnboardingClick = () => {
      setIsButtonLoading(true); // Activeer de loading indicator
      localStorage.setItem("onBoardingInitiated", "true");
      
      if (onboardingLink?.url) {
         window.location.href = onboardingLink.url;
      } else {
         setIsButtonLoading(false); // Zet terug uit als er geen geldige URL is
      }
   };

   if (isLoading) {
      return <p>Onboardinglink laden...</p>;
   }

   if (isError || !onboardingLink) {
      return (
         <p className="c-r">
            Er is een fout opgetreden bij het ophalen van de onboardinglink.
         </p>
      );
   }

   return (
      <div className="g-20">
         <p>
            Om betalingen van klanten te kunnen ontvangen via je webshop, is het
            essentieel om het onboardingproces te voltooien. Tijdens de
            onboarding koppel je je Stripe-account, waarmee je betalingen kunt
            accepteren en veilig overboekingen naar je eigen bankrekening kunt
            ontvangen.
         </p>
         <div>
            <PrimaryButton onClick={handleOnboardingClick} disabled={isButtonLoading}>
               <span className="flex-1">
                  Ga naar Onboarding {isButtonLoading && <LoadingIndicatorButton />}
               </span>
            </PrimaryButton>
         </div>
      </div>
   );
};

export default OnboardingButton;
